import {FC, useCallback, useEffect, useState} from 'react'
import {SubClient, WebhookType} from '../../../../../services/cellcast.v2.types'
import {useSetSubClientWebhookMutation} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {Spinner} from 'react-bootstrap'

export type ApiOverviewProps = {
  reload: () => void
  isFetching: boolean
  data: SubClient | undefined
  setShowCreateModal: (show: boolean) => void
}

const ApiOverview: FC<ApiOverviewProps> = (props) => {
  const {data, setShowCreateModal} = props

  const [webHookStatus, setWebHookStatus] = useState('')
  const [webHookReceive, setWebHookReceive] = useState('')
  const [webhookOptOut, setWebhookOptOut] = useState('')

  const [setWebhook, {isLoading}] = useSetSubClientWebhookMutation()
  const [updateType, setUpdateType] = useState<WebhookType | string>('')

  useEffect(() => {
    if (data && data.webHooks && Array.isArray(data.webHooks)) {
      data.webHooks.forEach((el) => {
        if (!el) {
          return
        }

        if (el.type && el.type === WebhookType.Receive) {
          setWebHookReceive(el.url)
        }

        if (el.type && el.type === WebhookType.Status) {
          setWebHookStatus(el.url)
        }

        if (el.type && el.type === WebhookType.Unsubscribe) {
          setWebhookOptOut(el.url)
        }
      })
    }
  }, [data])

  const handleSetWebhookUrl = useCallback(
    (type: WebhookType) => {
      let url = ''
      if (type === WebhookType.Receive) {
        url = webHookReceive
      }

      if (type === WebhookType.Status) {
        url = webHookStatus
      }

      if (type === WebhookType.Unsubscribe) {
        url = webhookOptOut
      }

      setUpdateType(type)
      setWebhook({
        id: data ? data._id : '',
        data: {
          type: type,
          url: url,
        },
      })
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
        .then(() => {
          setUpdateType('')
        })
    },
    [webHookReceive, webHookStatus]
  )

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer d-flex justify-content-between'
        role='button'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0 fs-2'>API Overview</h3>
        </div>
      </div>
      <div className='card-body border-top'>
        <div className='row gx-9 gy-6'>
          <div className='col-xl-6'>
            <div
              className='card  h-xl-100 align-items-start   justify-content-start flex-wrap p-6'
              style={{
                gap: '30px',
              }}
            >
              <div className='d-flex flex-column py-2'>
                <div className='d-flex align-items-center fs-4 fw-bolder mb-5'>How to set API</div>
                <div className='d-flex align-items-center'>
                  <div>
                    <div className='fs-7 fw-light text-gray-600'>
                      Seamlessly integrate SMS to your workflow <br />
                      Setting up your API connection is as simple as creating a new API key. <br />
                      Here's how : <br />
                      <a className='fw-bolder' href='https://developer.cellcast.com/getting-started/api-key.html' target='_blank' rel='noreferrer'>
                        API set up
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex align-items-center py-2'>
                <button
                  onClick={() => setShowCreateModal(true)}
                  className='btn btn-sm btn-primary btn-active-light-primary text-white me-3'
                >
                  New API Key
                </button>
              </div>
            </div>
          </div>
          <div className='col-xl-6'>
            <div className='card  h-xl-100  flex-wrap p-6'>
              <div className='d-flex flex-column py-2'>
                <div className='d-flex align-items-center fs-4 fw-bolder mb-5'>Developer Tools</div>
              </div>
              <div className='d-flex align-items-center py-2 flex-column'>
                <div className='py-3 align-items-center w-100'>
                  <label>Receive URL</label>
                  <div className='d-flex'>
                    <input
                      value={webHookReceive}
                      onChange={(e: any) => setWebHookReceive(e.target.value)}
                      className='form-control form-control-lg form-control-solid msg_tags me-3'
                    />
                    <button
                      disabled={
                        webHookReceive.length > 0
                          ? !/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                              webHookReceive
                            )
                          : false
                      }
                      className='btn btn-primary'
                      onClick={() => handleSetWebhookUrl(WebhookType.Receive)}
                    >
                      {updateType === WebhookType.Receive && isLoading ? (
                        <Spinner size='sm' />
                      ) : (
                        'Update'
                      )}
                    </button>
                  </div>
                </div>
                <div className='py-3 align-items-center w-100'>
                  <label>Status URL</label>
                  <div className='d-flex'>
                    <input
                      value={webHookStatus}
                      onChange={(e: any) => setWebHookStatus(e.target.value)}
                      className='form-control form-control-lg form-control-solid msg_tags me-3'
                    />
                    <button
                      disabled={
                        webHookStatus.length > 0
                          ? !/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                              webHookStatus
                            )
                          : false
                      }
                      className='btn btn-primary'
                      onClick={() => handleSetWebhookUrl(WebhookType.Status)}
                    >
                      {updateType === WebhookType.Status && isLoading ? (
                        <Spinner size='sm' />
                      ) : (
                        'Update'
                      )}
                    </button>
                  </div>
                </div>
                <div className='py-3 align-items-center w-100'>
                  <label>Opt-Out URL</label>
                  <div className='d-flex'>
                    <input
                      value={webhookOptOut}
                      onChange={(e: any) => setWebhookOptOut(e.target.value)}
                      className='form-control form-control-lg form-control-solid msg_tags me-3'
                    />
                    <button
                      disabled={
                        webhookOptOut.length > 0
                          ? !/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                              webhookOptOut
                            )
                          : false
                      }
                      className='btn btn-primary'
                      onClick={() => handleSetWebhookUrl(WebhookType.Unsubscribe)}
                    >
                      {updateType === WebhookType.Unsubscribe && isLoading ? (
                        <Spinner size='sm' />
                      ) : (
                        'Update'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApiOverview
